import { Link } from "react-router-dom";
import { Typography } from "@circle-react-uikit/Typography";

export const ConversationItem = ({ conversation }) => {
  const { id, subject } = conversation;

  return (
    <Link
      to={`/conversations/${id}`}
      className="text-dark hover:bg-tertiary hover:text-dark focus:bg-secondary focus:text-dark cursor-pointer px-6 py-2"
    >
      <div className="flex justify-between">
        <Typography.LabelSm truncate weight="normal">
          {subject}
        </Typography.LabelSm>
      </div>
    </Link>
  );
};
